import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type { EditableFilter } from '@atlassian/jira-filters-common/src/model/index.tsx';
import { SharingPermissionAwareShareableEntityModal } from '@atlassian/jira-shareable-entity-dialog/src/index.tsx';
import type {
	OperationData,
	OperationResult,
	ServerValidationErrors,
} from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';
import type { Intl, BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { SharePermission } from '@atlassian/jira-shared-types/src/share-permission.tsx';
import messages from './messages.tsx';

export type OwnProps = {
	readonly baseUrl: BaseUrl;
	readonly name: string;
	readonly description: string | undefined;
	readonly sharePermissions: SharePermission[];
	readonly editPermissions: SharePermission[];
	readonly getServerSideValidationErrors: (arg1: ValidationError) => ServerValidationErrors;
	// eslint-disable-next-line jira/react/handler-naming
	readonly operation: (arg1: EditableFilter) => Promise<void>;
	readonly onOperationSucceed: (
		arg1: OperationData,
		arg2: OperationResult<undefined>,
		arg3: UIAnalyticsEvent,
	) => void;
	readonly onOperationFailed: (arg1: Error, arg2: UIAnalyticsEvent) => void;
	readonly onCancel: () => void;
};

export type Props = Intl & OwnProps;

export function EditModal(props: Props) {
	const {
		intl: { formatMessage },
		name,
		description,
		onCancel,
		...restProps
	} = props;

	// Use sharing permission aware modal instead of one which doesn't respect global sharing setting
	return (
		// @ts-expect-error - TS2322 - Type '{ sharePermissions: SharePermission[]; editPermissions: SharePermission[]; getServerSideValidationErrors: (arg1: ValidationError) => Partial<...>; ... 10 more ...; onCancel: () => void; }' is not assignable to type 'Diff<AppProps<undefined>, { shareeOptions: Option[]; isEditorListShown: boolean; editOptions: Option[]; isShareScopeLoading?: boolean | undefined; }>'.
		<SharingPermissionAwareShareableEntityModal
			sharingPermissionType="filter"
			avoidInitialPublicSharePermission={false}
			title={formatMessage(messages.title)}
			actionButtonCaption={formatMessage(messages.submitButtonCaption)}
			initialName={name}
			initialDescription={description}
			initialOwner={undefined}
			onCancel={onCancel}
			{...restProps}
		/>
	);
}

export default EditModal;
